module.exports = __webpack_public_path__ + "img/tanzania.70dd4d9b.svg";